import { memo } from 'react'
import { useFilters } from '../../filters3/filters/hooks/useFilters'
import { trackAnalyticsEvent } from '../../../../core/hooks/useAnalytics'
import { useTranslation } from 'react-i18next'

const ApplyButton = () => {
  const { t } = useTranslation()
  const { apply, changed, isValid } = useFilters()

  const handleClickOnApplyButton = () => {
    trackAnalyticsEvent('click_apply_filter')
    apply()
  }

  const disabled = !changed || !isValid

  return (
    <button
      type="button"
      data-testid={`filters-apply-btn${disabled ? '-disabled' : ''}`}
      className="vtmn-btn vtmn-btn_variant--primary vtmn-btn_size--small"
      disabled={disabled}
      onClick={handleClickOnApplyButton}
    >
      {t('filters.apply')}
    </button>
  )
}

export default memo(ApplyButton)
